

document.addEventListener('DOMContentLoaded', function () {
    let items = document.querySelectorAll(".header__inline-menu details summary");

    items.forEach((item) => {
        // Skip the Products menu (has class 'Products')
        let parentLi = item.closest('li');
        if (parentLi && parentLi.classList.contains('Products')) return;

        item.addEventListener("mouseover", () => {
            item.setAttribute("open", "true");
            let megaMenu = item.querySelector(".mega-menu__content");
            if (megaMenu) megaMenu.style.display = 'block';
        });

        item.addEventListener("mouseleave", () => {
            item.removeAttribute("open");
            let megaMenu = item.querySelector(".mega-menu__content");
            if (megaMenu) megaMenu.style.display = 'none';
        });
    });
});

$(document).ready(function () {
  /** -------------------------------
   * 1. Move menu on load
   * ------------------------------- */
  $('#HeaderMenu-MenuList-1').insertAfter('.top-inline-bar');

  /** -------------------------------
   * 2. Hover logic for all menus except "Products"
   * ------------------------------- */
  $(".header__inline-menu details").each(function () {
    const $details = $(this);
    const $summary = $details.find("summary").first();
    const $megaMenu = $details.find(".mega-menu__content");
    const $submenu = $details.find("ul.header__submenu");
    const $parentLi = $details.closest("li");

    // Skip Products menu
    if ($parentLi.hasClass("Products")) return;

    // Hide menus initially
    if ($megaMenu.length) $megaMenu.hide();
    if ($submenu.length) $submenu.hide();

    // Hover open
    $details.on("mouseenter", function () {
      $details.attr("open", "true");

      if ($megaMenu.length) {
        $megaMenu.stop(true, true)
          .css({ display: "block", height: 0, opacity: 0 })
          .animate({ height: $megaMenu.get(0).scrollHeight, opacity: 1 }, 300);
      }

      if ($submenu.length) {
        $submenu.stop(true, true)
          .css({ display: "block", height: 0, opacity: 0 })
          .animate({ height: $submenu.get(0).scrollHeight, opacity: 1 }, 300);
      }
    });

    // Hover close
    $details.on("mouseleave", function () {
      $details.removeAttr("open");

      if ($megaMenu.length) {
        $megaMenu.stop(true, true)
          .animate({ height: 0, opacity: 0 }, 300, function () {
            $(this).hide();
          });
      }

      if ($submenu.length) {
        $submenu.stop(true, true)
          .animate({ height: 0, opacity: 0 }, 300, function () {
            $(this).hide();
          });
      }
    });

    // Click redirect to data-url
    $summary.on("click", function (e) {
      e.preventDefault();
      const targetUrl = $details.attr("data-url");
      if (targetUrl) {
        window.location.href = targetUrl;
      }
    });
  });

  /** -------------------------------
   * 3. Click behavior for "Products" mega menu
   * ------------------------------- */
  const dropdownBtn = document.querySelector('.mega-dropdown');
  const detailsMenu = document.querySelector('#Details-HeaderMenu-1');

  if (dropdownBtn && detailsMenu) {
    const $detailsMenu = $(detailsMenu);

    // Remove any hover logic if exists
    $detailsMenu.off('mouseenter mouseleave');

    // Click toggle
    dropdownBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      const isOpen = $('body').hasClass('mega-menu-open');

      if (isOpen) {
        $('body').removeClass('mega-menu-open');
        $detailsMenu.removeAttr('open');
        $('.mega-menu__content', $detailsMenu).slideUp(300);
      } else {
        $('body').addClass('mega-menu-open');
        $detailsMenu.attr('open', 'true');
        $('.mega-menu__content', $detailsMenu).slideDown(300);
      }
    });

    // Close when clicking outside
    $(document).on('click', function (e) {
      if (!$(e.target).closest('.mega-dropdown, #Details-HeaderMenu-1').length) {
        $('body').removeClass('mega-menu-open');
        $detailsMenu.removeAttr('open');
        $('.mega-menu__content', $detailsMenu).slideUp(300);
      }
    });
  }
});

function refreshCartIconBubble(cartData) {
  if (!cartData) return;

  if (typeof window.rushFeeUpdateCartBubbleCount === 'function') {
    window.rushFeeUpdateCartBubbleCount(cartData);
  } else {
    const cartDrawer = document.querySelector('cart-drawer');
    const cartDrawerItems = cartDrawer?.querySelector('cart-drawer-items');

    if (cartDrawerItems?.updateDrawerCartBubble) {
      cartDrawerItems.updateDrawerCartBubble(cartData);
    } else if (cartDrawerItems?.updateCartIconBubble) {
      cartDrawerItems.updateCartIconBubble(cartData);
    }
  }

  document.dispatchEvent(
    new CustomEvent('cart:updated', { detail: { item_count: cartData.item_count } })
  );
}

function syncCartIconFromServer() {
  return fetch('/cart.js')
    .then((response) => response.json())
    .then((cartData) => {
      refreshCartIconBubble(cartData);
      return cartData;
    })
    .catch((error) => console.error('Cart icon sync error:', error));
}

if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    if (event.cartData?.item_count != null) {
      refreshCartIconBubble(event.cartData);
      return;
    }

    syncCartIconFromServer();
  });
}

document.addEventListener('click', function (e) {
  const btn = e.target.closest('.add_to_cart, .addToCart-btn, .quick-add__submit');
  if (!btn || btn.disabled) return;

  // product-form already updates the cart icon after a successful add
  if (btn.closest('product-form')) return;

  setTimeout(() => {
    syncCartIconFromServer().then((cartData) => {
      if (!cartData) return;

      const cartDrawer = document.querySelector('cart-drawer');
      if (!cartDrawer) return;

      if (cartDrawer.classList.contains('is-empty')) {
        cartDrawer.classList.remove('is-empty');
      }

      fetch('/?sections=cart-drawer,cart-icon-bubble')
        .then((response) => response.json())
        .then((data) => {
          const cartDrawerItems = cartDrawer.querySelector('cart-drawer-items');
          if (data['cart-drawer'] && cartDrawerItems?.replaceCartDrawerContents) {
            cartDrawerItems.replaceCartDrawerContents(data['cart-drawer']);
          }

          const bubblePayload = {
            item_count: cartData.item_count,
            items: cartData.items,
            sections: { 'cart-icon-bubble': data['cart-icon-bubble'] },
          };

          if (cartDrawerItems?.updateDrawerCartBubble) {
            cartDrawerItems.updateDrawerCartBubble(bubblePayload);
          } else if (cartDrawerItems?.updateCartIconBubble) {
            cartDrawerItems.updateCartIconBubble(bubblePayload);
          } else {
            refreshCartIconBubble(bubblePayload);
          }
        })
        .catch((error) => console.error('Cart drawer refresh error:', error));

      document.dispatchEvent(new CustomEvent('cart:refresh'));
    });
  }, 400);
});

// Back/forward cache se return par page reload kare
window.onpageshow = function (event) {
  if (
    event.persisted ||
    (window.performance && window.performance.getEntriesByType('navigation')[0].type === 'back_forward')
  ) {
    window.location.reload();
  }
};

/**
 * Keep PDP wishlist heart visible after multi-variant / combined-listing swaps.
 * iWish injects SVG on init; after AJAX HTML swaps that icon can disappear.
 */
window.refreshPdpWishlist = function refreshPdpWishlist(root) {
  const scope = root && root.querySelectorAll ? root : document;
  const buttons = scope.querySelectorAll('.pdp-wishlisht .iWishAddColl, .pdp-wishlisht .iWishAdd');
  const heartSvg =
    '<svg class="iwishOutline icon icon-wishlisht" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 21 21" fill="none" aria-hidden="true"><path d="M13.7498 3.83301C16.3915 3.83301 18.1665 6.31634 18.1665 8.63301C18.1665 13.3247 10.7998 17.1663 10.6665 17.1663C10.5332 17.1663 3.1665 13.3247 3.1665 8.63301C3.1665 6.31634 4.9415 3.83301 7.58317 3.83301C9.09984 3.83301 10.0915 4.59134 10.6665 5.25801C11.2415 4.59134 12.2332 3.83301 13.7498 3.83301Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg>';

  buttons.forEach((btn) => {
    if (!btn.querySelector('svg')) {
      btn.insertAdjacentHTML('afterbegin', heartSvg);
    }
    btn.style.display = '';
    btn.classList.remove('hidden');
  });

  // Re-init iWish so the heart stays interactive after DOM swaps
  try {
    if (typeof window.iWishInit === 'function') window.iWishInit();
    else if (typeof window.iwishInit === 'function') window.iwishInit();
    else if (window.jQuery && jQuery.iWish && typeof jQuery.iWish.init === 'function') jQuery.iWish.init();
  } catch (e) {
    console.warn('Wishlist re-init skipped:', e);
  }

  document.dispatchEvent(new CustomEvent('iwish:refresh', { bubbles: true }));
  document.dispatchEvent(new CustomEvent('wishlist:init', { bubbles: true }));
};
